import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResumesFilterOption extends BaseModel {
  static override constructorName = 'ResumesFilterOptionModel'

  id: string | number = ''
  name: string = ''
  value: boolean = false

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResumesFilterOption)
